module.exports = __webpack_public_path__ + "static/media/aboutPhoto.6c9d365b.png";